export default __webpack_public_path__ + "static/media/green.9d0fceee.png";